import React, { useState, useEffect } from "react";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { Link } from "react-router-dom";
import { FaPlus } from "react-icons/fa6";
import cash_delivery from "../assets/images/cash-delivery.png";
import SuccessPopup from "../components/SuccessPopup";
import { useLocation, useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";
import PageLoader from "../components/PageLoader";
import { toast } from "react-toastify";
import Header from "../components/Header";
import PaymentSection from "../components/PaymentSection";
import Swal from 'sweetalert2';
import AuthService from "../services/AuthService";


const Checkout = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [paymentMethod, setPaymentMethod] = useState('COD');
    const [orderId, setOrderId] = useState('');
    const [activeTab, setActiveTab] = useState(localStorage.getItem('type') || 'delivery');
    const address = JSON.parse(localStorage.getItem("address"));
    const branch = JSON.parse(localStorage.getItem("branch"));
    const promo_code = localStorage.getItem("promo_code");
    const searchParams = new URLSearchParams(window.location.search);
    const offer = searchParams.get('offer') || '';
    const apply_loyalty = localStorage.getItem("apply_loyalty");

    const [cart, setCart] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [isPlacingOrder, setIsPlacingOrder] = useState(false);
    const authUser = AuthService.getCurrentUser();




    const navigate = useNavigate();
    const { pathname } = useLocation();
    
    useEffect(() => {
      window.scrollTo(0, 0);

      // Returning from the Checkout Flow page (success_url / failure_url redirect,
      // or the in-SPA navigate from onPaymentCompleted).
      const status = searchParams.get('status');
      if (status) {
        handlePaymentReturn(status);
        return; // skip cart load — the webhook may have already cleared the cart
      }

      getCart();
      setPaymentMethod((activeTab == 'pickup') ? 'COP' : 'COD');
    }, [pathname]);

  const getCart = async () => {
    try {
      setIsLoader(true);
      let apiData= {type: activeTab, user_address_id: address?._id,branch_id: branch?._id};

      if(promo_code){
        apiData.promo_code = promo_code;
      } else if(offer){
        apiData.promo_code = offer;
      }
      if(String(apply_loyalty)=="true"){
        apiData.apply_loyalty = apply_loyalty;
      }

      const response = await ApiService.request({
        method: "GET",
        url: "/getCart",
        data: apiData
      });
      const data = response.data;

      if (data.status) {
        const items=data.data.cartItems || [];
        if(items.length < 1){
          toast.info("Your cart is empty! Please add items to your cart.");
          navigate('/items');
          return;
        }

        setCart(data.data);
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
    }
  };

  const placeOrder = async () => {
    try {
      setIsLoader(true);
      setIsPlacingOrder(true);

      // Card payments are created with payment_method 'Card' so the backend defers
      // fulfillment (cart clear / notifications) until the payment is confirmed via
      // the Checkout.com webhook after the customer pays on the Flow page.
      const isCard = paymentMethod === 'Card';

      const formData = {
        order_from: 'Web',
        delivery_instruction: localStorage.getItem('delivery_instruction'),
        payment_method: isCard ? 'Card' : paymentMethod,
      };
      if (activeTab === 'delivery') {
        formData.user_address_id = address._id;
      } else {
        formData.branch_id = branch._id;
      }
      if (promo_code) {
        formData.promo_code = promo_code;
      } else if (offer) {
        formData.promo_code = offer;
      }
      if (String(apply_loyalty) == "true") {
        formData.loyalty_points = cart.loyalty_points;
      }

      const response = await ApiService.request({
        method: "POST",
        url: "/placeOrder",
        data: formData,
      });
      const data = response.data;

      if (!data.status) {
        toast.error(data.message);
        return;
      }

      const newOrderId = data.data.order._id;

      // ── Card → hand off to the Checkout Flow payment page to charge it ──
      if (isCard) {
        localStorage.setItem('pending_order_id', newOrderId);
        navigate(`/pay?order_id=${newOrderId}&user_id=${authUser._id}`);
        return;
      }

      // ── COD / COP → confirm immediately ──
      finishOrder(newOrderId);

    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoader(false);
      setIsPlacingOrder(false);
    }
  };

  // Show the success popup and clear checkout-related local state.
  const finishOrder = (id) => {
    setOrderId(id);
    setShowPopup(true);
    localStorage.removeItem('promo_code');
    localStorage.removeItem('apply_loyalty');
    localStorage.removeItem('cart_count');
    localStorage.removeItem('pending_order_id');
  };

  // Strip the ?status=... query params so a refresh doesn't re-trigger this.
  const clearStatusFromUrl = () => {
    window.history.replaceState({}, document.title, window.location.pathname);
  };

  // Handle the return trip from the Flow payment page.
  const handlePaymentReturn = async (status) => {
    if (status === 'failed') {
      await Swal.fire({
        title: 'Payment Failed!',
        text: 'Your payment could not be completed. Please try again.',
        icon: 'warning',
        confirmButtonColor: '#9E9B9B',
        confirmButtonText: 'OK',
      });
      clearStatusFromUrl();
      navigate('/checkout', { replace: true });
      return;
    }

    if (status === 'succeeded') {
      const paymentId = searchParams.get('cko-payment-id');
      const pendingOrderId = localStorage.getItem('pending_order_id');
      try {
        setIsPlacingOrder(true);

        if (pendingOrderId) {
          // Confirm the payment server-side: the backend verifies it with
          // Checkout.com, then marks the order Paid, clears the cart and runs
          // fulfillment (notifications, loyalty, Foodics). This is the fallback
          // for when the CKO webhook can't reach the backend — it's idempotent,
          // so it's safe even if the webhook also fired.
          const res = await ApiService.request({
            method: "POST",
            url: "/confirmPayment",
            data: { order_id: pendingOrderId, paymentId },
          });

          if (!res.data?.status) {
            await Swal.fire({
              title: 'Payment Failed!',
              text: res.data?.message || 'Your payment was not successful. Please try again.',
              icon: 'warning',
              confirmButtonColor: '#9E9B9B',
              confirmButtonText: 'OK',
            });
            clearStatusFromUrl();
            return;
          }

          finishOrder(pendingOrderId);
        }
      } catch (error) {
        console.error("Payment verification error:", error);
      } finally {
        setIsPlacingOrder(false);
        clearStatusFromUrl();
      }
    }
  };


  const removePromo = () => {
    localStorage.removeItem('promo_code');
    // If there's an offer in URL, we can't remove it from checkout
    // User needs to go back to cart to remove it
    if (offer) {
      toast.info("Please go back to cart to remove this offer");
      return;
    }
    toast.success("Promo code removed successfully");
    getCart(); // Refresh cart to recalculate totals
  };

  return (
    <div className="main-heading container">
      
      <Header title={'Checkout'} back={'/cart'}/>
      

      <div className="d-flex justify-content-center align-items-center">
        {activeTab=='delivery' ?(
          <iframe
            src={'https://www.google.com/maps?q=' + address?.lat + ',' + address?.lng + '&hl=es;z=14&output=embed'}
            width="100%"
            height="200"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        ):(
          <iframe
            src={'https://www.google.com/maps?q=' + branch?.lat + ',' + branch?.lng + '&hl=es;z=14&output=embed'}
            width="100%"
            height="200"
            allowfullscreen=""
            loading="lazy"
            referrerpolicy="no-referrer-when-downgrade"
          ></iframe>
        )}
        
      </div>
      {activeTab==='delivery' ? (
        <div className="">
          <div className="py-2 px-3 mx-2 border-bottom">
            <p className="text-capitalize fw-semibold my-2">Deliver To - {address?.type}</p>
            <div className="d-flex justify-content-between">
              <p>{address?.address}</p>
              <Link to='/address-list?goto=checkout' className="text-base fw-bold cart-discount-p">Change</Link>
            </div>
          </div>
          <Link to="/add-address"
            className="p-2 mx-3 border-bottom d-flex address-section justify-content-start align-items-center">
            <FaPlus />
            <p className="cart-discount-p mt-3 mx-2 fs-6">Add New Address</p>
          </Link>
        </div>
      ):(
        <div className="py-2 px-3 mx-2 border-bottom">
          <p className="text-capitalize fw-semibold my-2">Pickup From - {branch?.name}</p>
          <div className="d-flex justify-content-between">
            <p>{branch?.location}</p>
            <Link to='/?tab=pickup&change=true&goto=checkout' className="text-base fw-bold cart-discount-p">Change</Link>
          </div>
        </div>
      )}
      

     

      <PaymentSection
        activeTab={activeTab}
        paymentMethod={paymentMethod}
        setPaymentMethod={setPaymentMethod}
      />

        <div className="mt-4 border-bottom px-3">
          <h4>Order Summary</h4>
          {cart.cartItems && cart.cartItems.map((item, index) => (
            <div className="d-flex justify-content-between">
              <p>{item?.item?.title}</p>
              <p>AED {item?.total_price}</p>
            </div>
          ))}
         
        </div>

        <div className="d-flex justify-content-between border-bottom mt-3 px-3">
          <p className="text-secondary">Subtotal</p>
          <p className="text-secondary">AED {cart.subTotal}</p>
        </div>
        {cart.deliveryCharges > 0 &&
          <div className="d-flex justify-content-between border-bottom mt-3 px-3">
            <p className="text-secondary">Delivery Fee</p>
            <p className="text-secondary">AED {cart.deliveryCharges}</p>
          </div>
        }
        {cart.vat_amount > 0 &&
          <div className="d-flex justify-content-between border-bottom mt-3 px-3">
            <p className="text-secondary">VAT</p>
            <p className="text-secondary">AED {cart.vat_amount}</p>
          </div>
        }
        {cart.promo_discount > 0  &&
          <div className="d-flex justify-content-between border-bottom mt-3 px-3">
            <p className="text-secondary">
              {(offer) ? 'Offer' : 'Promo Code'} Discount: {promo_code || offer}
              <span 
                onClick={removePromo}
                className="bi bi-x fs-4 text-dark pt-2 cursor-pointer ms-2"
                style={{cursor: 'pointer'}}
                title="Remove promo code"
              ></span>
            </p>
            <p className="text-secondary">AED {cart.promo_discount}</p>
          </div>
        }
        {(String(apply_loyalty)=="true" && cart.loyalty_discount > 0)  &&
          <div className="d-flex justify-content-between border-bottom mt-3 px-3">
            <p className="text-secondary">Redeem Points </p>
            <p className="text-secondary">AED {cart.loyalty_discount}</p>
          </div>
        }
        <div className="text-secondary border-bottom mt-3 px-3">
          <p>
            by completing this order, I agree to all
            <span className="cart-discount-p"> terms & conditions.</span>
          </p>
        </div>
        <div className="d-flex justify-content-between align-items-center border-bottom my-4 px-3">
          <h5 className="fw-light">
            <span className="fw-bold">Total</span> (incl.VAT)
          </h5>
          <h5 className="fw-bold">AED {cart.grand_total}</h5>
        </div>
        <div className="cart-btn placeOrder d-flex justify-content-center align-items-center">
          <button disabled={isLoader || isPlacingOrder}
            className="place-order-btn btn rounded btn-lg ms-3 text-white"
            onClick={placeOrder}
          >
            {paymentMethod === 'Card' ? 'Continue to Payment' : 'Place Order'}
            {(isLoader || isPlacingOrder) &&  <span className="spinner-border spinner-border-sm "  role="status"></span>}
          </button>
        </div>
        {showPopup && <SuccessPopup orderId={orderId} onClose={() => setShowPopup(false)} />}
      
      {/* Order Placing Loader Overlay */}
      {isPlacingOrder && (
        <div className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" 
             style={{backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 9999}}>
          <div className="bg-white rounded-3 p-4 text-center shadow-lg">
            <div className="spinner-border text-primary mb-3" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <h5 className="text-dark mb-2">Placing Your Order</h5>
            <p className="text-muted mb-0">Please wait while we process your order...</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Checkout;
